import React from 'react';

export default ({ message }) => {
  return <span className='red-text'>{message}</span>;
};
